/***轨道流动线 */
import {
  IOverlayParameter,
  IResult,
  IHeatParameter,
  IHeatPoint
} from "@/types/map";
import {loadModules} from "esri-loader";
import echartsLayer from "./echartsLayer";

export class SubwayLine {
  private static intances: Map<string, any>;
  private view!: any;
  private echartlayer: any;
  private colors: Array<string> = [
    "rgba(0,255,255,0.4)",
    "rgba(255,255,0,0.4)",
    "rgba(255,215,0,0.4)",
    "rgba(255,69,0,0.4)",
    "rgba(0,250,154,0.4)",
    "rgba(0,255,0,0.4)",
    "rgba(255,0,0,0.4)",
    "rgba(255,20,147,0.4)",
    "rgba(0,191,255,0.4)"
  ];

  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView | __esri.SceneView) {
    let id = view.container.id;
    if (!SubwayLine.intances) {
      SubwayLine.intances = new Map();
    }
    let intance = SubwayLine.intances.get(id);
    if (!intance) {
      intance = new SubwayLine(view);
      SubwayLine.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (SubwayLine.intances as any) = null;
  }

  public async hideSubwayLine() {
    this.clear();
  }
  private clear() {
    if (this.echartlayer) {
      //this.view.map.remove(this.echartlayer);
      this.echartlayer.removeLayer();
      this.echartlayer = null;
    }
  }

  private getColor(alph: number): string {
    let color = "rgb(255,255,255)";
    let r = Math.floor(Math.random() * 255);
    let g = Math.floor(Math.random() * 255);
    let b = Math.floor(Math.random() * 255);
    let a = alph;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
  }
  public async showSubwayFlow(params: any) {
    let _this = this;
    let sublayerUrl = params && params.url ? params.url : "";
    let features = params.features || [];
    let deaultOption = {
      symbolSize: 10,
      period: 7,
      color: "rgba(0,255,0,0.6)",
      trailLength: 0.6
    };
    let opt = params && params.chartOption ? params.chartOption : deaultOption;
    if (sublayerUrl === "") {
      this.view.map.allLayers.toArray().forEach((layer: any) => {
        if (layer.type == "map-image" && layer.showFlow) {
          layer.allSublayers.forEach((sublayer: any) => {
            if (sublayer.title == "line") {
              sublayerUrl = sublayer.url;
            }
          });
        } else if (layer.type == "feature" && layer.showFlow) {
          sublayerUrl = layer.url + "/" + layer.layerId;
        }
      });
    }
    if (sublayerUrl) {
      if (features.length > 0) {
        _this.showPathChart(features, opt);
      } else {
        this.doQueryTask(sublayerUrl).then((res: any) => {
          _this.showPathChart(res, opt);
        });
      }
    }
  }
  private async showPathChart(res: any, opt: any) {
    this.clear();
    let chartslines: any[] = [];
    let wkid = 3857;
    res.forEach((graphic: any, index: number) => {
      let fields = graphic.attributes;
      let lineid =
        fields["line.SECTIONID"] || fields["SECTIONID"] || fields["OBJECTID"];
      let yflow =
        fields["YJZH.STAT_METROLINEFLOW.VOLUME_YESTERDAY"] ||
        fields["VOLUME_YESTERDAY"];
      let tflow =
        fields["YJZH.STAT_METROLINEFLOW.VOLUME_TODAY"] ||
        fields["VOLUME_TODAY"] ||
        12;
      let geometry = graphic.geometry;
      wkid = geometry.spatialReference.isWebMercator ? 3857 : 4326;
      geometry.paths.forEach((item: any) => {
        let line: {coords?: any; lineStyle?: any; value?: number} = {};
        line.value = tflow;
        line.lineStyle = {
          normal: {
            color: opt.color || "rgba(0,255,0,0.6)",
            width: 0,
            opacity: 0.1
          }
        };
        line.coords = item;
        chartslines.push(line);
      });
    });

    let series = [
      // {
      //   type: 'lines',
      //   coordinateSystem: 'arcgis',
      //   polyline: true,
      //   data: chartslines,
      //   silent: true,
      //   smooth: true,
      //   lineStyle: {
      //     // color: '#c23531',
      //     // color: 'rgb(200, 35, 45)',
      //     opacity: 0.1
      //     //width: 4
      //   },
      //   progressiveThreshold: 500,
      //   progressive: 200
      // },
      {
        type: "lines",
        coordinateSystem: "arcgis",
        polyline: true,
        data: chartslines,
        smooth: true,
        lineStyle: {
          width: 0
        },
        effect: {
          //constantSpeed: 60,
          period: opt.period || 7,
          show: true,
          trailLength: opt.trailLength || 0.6, //小尾巴长度0.2
          symbolSize: opt.symbolSize || 10
        },
        zlevel: 1
      }
    ];
    this.echartlayer = new echartsLayer(this.view, {wkid});
    var option = {
      series: series
    };
    this.echartlayer.setChartOption(option);
  }
  private async doQueryTask(queryUrl: any): Promise<any> {
    type MapModules = [
      typeof import("esri/tasks/QueryTask"),
      typeof import("esri/tasks/support/Query")
    ];
    const [QueryTask, Query] = await (loadModules([
      "esri/tasks/QueryTask",
      "esri/tasks/support/Query"
    ]) as Promise<MapModules>);
    return new Promise((resolve, reject) => {
      var queryTask = new QueryTask({
        url: queryUrl
      });
      var query = new Query();
      query.returnGeometry = true;
      query.outFields = ["*"];
      query.where = "1=1";
      query.outSpatialReference = this.view.spatialReference;
      // When resolved, returns features and graphics that satisfy the query.
      queryTask.execute(query).then(function(results) {
        resolve(results.features);
      });
    });
  }
}
